import { render, staticRenderFns } from "./Calificacion.vue?vue&type=template&id=c6dbada0&scoped=true"
import script from "./Calificacion.vue?vue&type=script&lang=js"
export * from "./Calificacion.vue?vue&type=script&lang=js"
import style0 from "./Calificacion.vue?vue&type=style&index=0&id=c6dbada0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dbada0",
  null
  
)

export default component.exports